import { IMapDrawLayer, IMapGeometryWicket, IMapSettings } from "@components/map/map.settings";
import { orderBy } from "lodash";
import { IMapComponent } from "~app/common/components/map/map.models";
import { Barighetsklasser, TplMapLayerConstats } from "~app/common/models/constants";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { IGeolocationDto, ITplDestineringRuttQueryResult } from "~app/features/transport/transportplanera/models/queries";

export class TplTransportavstandKartaRutt {

    load(data: ITplDestineringRuttQueryResult, mapsettings: IMapSettings, map: IMapComponent, layerName: string) {
        const geometry = this.mapToGeometry(data);
        this.getRuttLayer(mapsettings, layerName).geometries = geometry;
        this.refreshRuttGeometries(data, map);
    }

    getLayer(id: string, title: string) {
        return {
            id: id,
            title: title,
            showGeometriesMenu: false,
            visible: true,
            readonly: true,
            geometries: [],
            selectable: false,
            hideInLayerList: true
        } as IMapDrawLayer;
    }

    private mapToGeometry(data: ITplDestineringRuttQueryResult): IMapGeometryWicket[] {
        const geometries: IMapGeometryWicket[] =[];
        data.arbetsorderTransportavtand.forEach(x => {
            if(!ObjectUtils.isNullOrUndefined(x.routeGeometry)) {
                geometries.push({
                    wkt: x.routeGeometry,
                    color: x.active ? this.getActiveColor(x.barighetsklass) : TplMapLayerConstats.bkInactiveRouteColor,
                    visible: true,
                    selected: x.active,
                    label: `${x.barighetsklass} Rutt`
                });
            }
        });
        return orderBy(geometries, x => x.selected);
    }

    private getActiveColor(barighetsklass: string): string {
        if (barighetsklass === Barighetsklasser.BK4) {
            return TplMapLayerConstats.bk4PrimaryRouteColor;
        }
        return TplMapLayerConstats.bk1PrimaryRouteColor;
    }

    private getRuttLayer(mapsettings: IMapSettings, layerName: string): IMapDrawLayer {
        return mapsettings.drawLayers.find(x => x.id === layerName);
    }

    private refreshRuttGeometries(data: ITplDestineringRuttQueryResult, map: IMapComponent) {
        if(map) {
            map.refreshGeometries(TplMapLayerConstats.ruttLayerName);
            this.triggerZoom(data, map);
        }
    }

    private triggerZoom(data: ITplDestineringRuttQueryResult, map: IMapComponent): void {
        if (ObjectUtils.hasValue(data.arbetsorderTransportavtand[0]?.routeGeometry) || ObjectUtils.hasValue(data.arbetsorderTransportavtand[1]?.routeGeometry)) {
            map.gotoAll([TplMapLayerConstats.ruttLayerName]);
            return;
        }

        const zoomTo: string[] = [];
        if (this.hasCoordinateValue(data?.startPunkt)) {
            zoomTo.push("startpunkt");
        }

        if (this.hasCoordinateValue(data?.slutPunkt)) {
            zoomTo.push("slutpunkt");
        }

        map.gotoAll(zoomTo);
    }

    private hasCoordinateValue(coord: IGeolocationDto): boolean {
        return !!(coord?.easting && coord?.northing);
    }
}
